// 순수 2-opt. 사이드이펙트 없음.
export function twoOptOptimize(
  coords,
  distanceFn,
  { fixStart = true, fixEnd = true } = {}
) {
  if (!Array.isArray(coords) || coords.length < 2) return coords.slice();

  let best = coords.slice();
  let bestD = distanceFn(best);

  const startI = fixStart ? 1 : 0;
  const endK = fixEnd ? best.length - 2 : best.length - 1;

  const swap = (route, i, k) =>
    route
      .slice(0, i)
      .concat(route.slice(i, k + 1).reverse(), route.slice(k + 1));

  let improved = true;
  while (improved) {
    improved = false;
    for (let i = startI; i < best.length - 1; i++) {
      for (let k = i + 1; k <= endK; k++) {
        const cand = swap(best, i, k);
        const d = distanceFn(cand);
        if (d < bestD) {
          best = cand;
          bestD = d;
          improved = true;
        }
      }
    }
  }
  return best;
}

// 간단 3D 거리/총거리 (필요하면 기존 로직으로 바꿔도 됨)
const R = 6371e3;
const toRad = (x) => (x * Math.PI) / 180;
export function haversine3D(a, b) {
  const dLat = toRad(b.lat - a.lat);
  const dLng = toRad(b.lng - a.lng);
  const lat1 = toRad(a.lat),
    lat2 = toRad(b.lat);
  const h =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(lat1) * Math.cos(lat2) * Math.sin(dLng / 2) ** 2;
  const flat = 2 * R * Math.atan2(Math.sqrt(h), Math.sqrt(1 - h));
  const dz = Number(b.alt || 0) - Number(a.alt || 0);
  return Math.hypot(flat, dz);
}
export function totalDistance(arr) {
  let s = 0;
  for (let i = 0; i < arr.length - 1; i++) s += haversine3D(arr[i], arr[i + 1]);
  return s;
}
